export default {
      id: "big-arrow-right-usage",
      viewBox: "0 0 99 32",
      url: "../../assets/" + "sprite.svg#big-arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }